import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { CreateLimiteProduit } from "../../core/model/limiteproduit/create-limite-produit";
import { LimiteProduitService } from "../../core/service/limite-produit.service";

@Component({
  selector: "app-add-limite-produit",
  templateUrl: "./add-limite-produit.component.html",
  styleUrls: ["./add-limite-produit.component.scss"],
})
export class AddLimiteProduitComponent implements OnInit {
  erreur: String = "";
  @Input() produitId;

  createLimiteProduit: CreateLimiteProduit = new CreateLimiteProduit();

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _limiteProduitService: LimiteProduitService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      limiteAutorise: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.createLimiteProduit.produitId = this.produitId;
    console.log(this.createLimiteProduit);
  }

  save(): void {
    this.pressButton = true;
    this._limiteProduitService
      .add(this.createLimiteProduit)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close();
        },
        (error) => {
          this.erreur = error.error.message;
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
